/**
 * 工单实体
 */
import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
    Upload,
    Image,
    ConfigProvider,
} from 'antd';
import $ from 'jquery';
import { PlusOutlined } from '@ant-design/icons';
import {
    locale,
    AddRequestHeaders,
    UjoinParams,
    AliyunOSSclient,
    AliyunOSSDelete,
    uuid,
    GetBase64,
    uploadImageButton,
    rff,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dateLocale from 'antd/es/date-picker/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
const MODULENAME = '工单信息';
const CURRENTTIME = currentDate + ' 00:00:00'

const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState('');
    const [productNumber, setProductNumber] = useState('');
    const [projectUlid, setProjectUlid] = useState('');
    const [type, setType] = useState('');
    const [level, setLevel] = useState(0);
    const [startTime, setStartTime] = useState(CURRENTTIME);
    const [endTime, setEndTime] = useState(CURRENTTIME);
    const [point, setPoint] = useState('');
    const [content, setContent] = useState('');
    const [cause, setCause] = useState('');
    const [doMode, setDoMode] = useState('');
    const [outFee, setOutFee] = useState(0);
    const [inFee, setInFee] = useState(0);
    const [perfWeight, setPerfWeight] = useState(1);
    const [doUser, setDoUser] = useState('');
    const [description, setDescription] = useState('');

    const [fileList, setFileList] = useState([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [deleteFileList, setDeleteFileList] = useState([]);
    const [woImageList, setWOImageList] = useState([]);

    const quit = () => {
        setLoading(false);
        props.setOpen(false);
        setNumber('');
        setProductNumber('');
        setProjectUlid('');
        setType('');
        setLevel(0);
        setStartTime(CURRENTTIME);
        setEndTime(CURRENTTIME);
        setPoint('');
        setContent('');
        setCause('');
        setDoMode('');
        setOutFee(0);
        setInFee(0);
        setPerfWeight(1);
        setDoUser('');
        setDescription('');

        setFileList([]);
        setPreviewOpen(false);
        setPreviewImage('');
        setDeleteFileList([]);
        setWOImageList([]);
    };

    const cancel = () => {
        if (!props.record) {
            // 新增情况下取消, 则删除已上传的图片
            aliyunOSSDeleteFileList(fileList);
            aliyunOSSDeleteFileList(deleteFileList);
        } else {
            // 修改取消情况下, 删除新增已上传的文件
            if (woImageList && woImageList.length > 0 && fileList.length > 0) {
                for (let i = 0; i < fileList.length; i++) {
                    let item = fileList[i];
                    // 如果不是原始图片则删除
                    if (!woImageList.find(e => e.path === fileList[i].path)) {
                        AliyunOSSDelete(item);
                    }
                }
            }
        }
        quit();
    };

    // 修改初始化数据
    useEffect(() => {
        /**
         * 获取工单图片列表
         */
        const getWoImageLists = (woUlid) => {
            const params = {
                'wo_ulid': woUlid,
                'start_date': '',
                'end_date': '',
                'page_size': CNF.pageSize,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}wo/images${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            let _woImageList = [];
                            let imageArr = data.dat;
                            if (imageArr.length > 0) {
                                let params = { 'acl': 'GetObject' }
                                $.ajax({
                                    url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                                    headers: AddRequestHeaders(),
                                    type: 'GET', success: function (data) {
                                        if (data.res === 0) {
                                            const token = data.dat;
                                            for (let i = 0; i < imageArr.length; i++) {
                                                let item = imageArr[i];
                                                try {
                                                    // 去掉路径‘/’
                                                    let result = AliyunOSSclient(token).signatureUrl(item.path, {
                                                        expires: 3600,
                                                        response: {
                                                            'content-disposition': 'attachment; filename="' + item.name + '"'
                                                        }
                                                    });
                                                    _woImageList.push({
                                                        uid: i + 1,
                                                        name: item.name,
                                                        ulid: item.key,
                                                        url: result,
                                                        preview: result,
                                                        status: 'done',
                                                        percent: 100,
                                                        size: item.size,
                                                        path: item.path,
                                                        description: item.description
                                                    });
                                                } catch (e) {
                                                    console.log(e);
                                                }
                                            }
                                            setWOImageList(_woImageList);
                                            setFileList(_woImageList);
                                        } else {
                                            messageApi.error(data.msg, CNF.messageDuration);
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            })
        }
        if (props.record) {
            setNumber(props.record.number);
            setProductNumber(props.record.product_number);
            setProjectUlid(props.record.project_ulid);
            setType(props.record.type);
            setLevel(props.record.level);
            setStartTime(props.record.start_time);
            setEndTime(props.record.end_time);
            setPoint(props.record.point);
            setContent(props.record.content);
            setCause(props.record.cause);
            setDoMode(props.record.do_mode);
            setOutFee(props.record.out_fee);
            setInFee(props.record.in_fee);
            setPerfWeight(props.record.perf_weight);
            setDoUser(props.record.do_user);
            setDescription(props.record.description);
            getWoImageLists(props.record.key);
        }
    }, [props.record, messageApi]);

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const handlePreview = (file) => {
        if (!file.preview) {
            if (file.originFileObj) {
                // 转换图片, 用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    const aliyunOSSUpload = (file, acl = 'private') => {
        const headers = {
            // 文件acl授权为公共读
            'x-oss-object-acl': acl
        }
        var params = {
            'acl': 'PutObject',
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    try {
                        let reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            // 路径由以下部分组成
                            // 项目代码+组织前缀+wos+uuid+附件名（去除空格）
                            let path = CNF.projectCode.toLowerCase()
                            path += '/wos';
                            path += '/' + props.preGroup;
                            path += '/' + uuid;
                            path += '/' + file.name.replace(/\s/g, '');
                            // 获取最新的文件列表
                            let newFileList = [...fileList];
                            AliyunOSSclient(token).multipartUpload(path, file,
                                {
                                    // 请求头
                                    headers,
                                    // 获取分片上传进度、断点和返回值
                                    progress: (p) => {
                                        setFileList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length - 1] = {
                                                ...newItems[newItems.length - 1],
                                                percent: parseInt(p * 100),
                                                name: file.name.replace(/\s/g, ''),
                                                status: p === 1 ? 'done' : 'uploading',
                                                url: CNF.ossApi + path,
                                                path: path,
                                                description: '',
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        });
                                    },
                                    // 分片数量
                                    parallel: Math.ceil(file.size / 1024 / 1024),
                                    // 设置分片大小, 默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    // 上传成功
                                    if (result.res.status === 200) { }
                                }).catch((e) => {
                                    // 上传失败
                                    messageApi.error(file.name + ' 上传失败！');
                                    // 删除上传失败文件
                                    setFileList(newFileList.pop());
                                });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
        return false
    }

    /**
     * 删除图片列表
     * @param {*} deleteFileArr 
     */
    const aliyunOSSDeleteFileList = (deleteFileArr) => {
        for (let file of deleteFileArr) {
            // 从阿里云上删除
            AliyunOSSDelete(file);
        }
        setDeleteFileList([]);
    }
    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        // 判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            messageApi.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 52428800) {
            messageApi.error('上传附近超过5M, 建议拆分文件！', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 确定绑定函数
     * @returns 
     */
    const ok = () => {
        // 参数校验
        if (number === '') {
            messageApi.error('工单编号不能为空！', CNF.messageDuration);
            return;
        }
        if (projectUlid === '') {
            messageApi.error('所属项目不能为空！', CNF.messageDuration);
            return;
        }
        if (type === '') {
            messageApi.error('工单类型不能为空！', CNF.messageDuration);
            return;
        }
        if (level === 0) {
            messageApi.error('工单等级不能为空！', CNF.messageDuration);
            return;
        }
        if (point === '') {
            messageApi.error('工单点位不能为空！', CNF.messageDuration);
            return;
        }
        if (content === '') {
            messageApi.error('工单描述不能为空！', CNF.messageDuration);
            return;
        }
        if (cause === '') {
            messageApi.error('工单原因不能为空！', CNF.messageDuration);
            return;
        }
        // 处理人员格式校验
        // 只允许中文、英文、数字、逗号和分号
        var rex = /^[， ,;；A-Za-z0-9\u4e00-\u9fa5]{2,}$/.exec(doUser)
        if (rex == null || rex[0] !== doUser) {
            messageApi.error("处理人员格式错误！", CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'wos' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'number': number,
                'product_number': productNumber,
                'project_ulid': projectUlid,
                'type': type,
                'level': level,
                'start_time': startTime,
                'end_time': endTime,
                'point': point,
                'content': content,
                'cause': cause,
                'do_mode': doMode,
                'out_fee': outFee,
                'in_fee': inFee,
                'perf_weight': perfWeight,
                'do_user': doUser,
                'description': description,
                'image_list': fileList.map((item) => ({
                    'name': item.name,
                    'url': item.url,
                    'path': item.path,
                    'size': item.size,
                    'description': item.description,
                })),
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    aliyunOSSDeleteFileList(deleteFileList);     // 同步删除阿里云文件
                    quit();
                    props.setRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <ConfigProvider locale={locale}>
            {contextHolder}
            <Modal
                width={820}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
                style={{ top: 0 }}
            >
                <Row>
                    <Col span={11}>{rff}工单编号</Col>
                    <Col span={11} offset={2}>产品编号</Col>
                    <Col span={11}>
                        <Input
                            placeholder='请输入, 形如: 202301010001'
                            onChange={(e) => setNumber(e.target.value)}
                            value={number}
                            disabled={loading}
                        />
                    </Col>

                    <Col span={11} offset={2}>
                        <Input
                            placeholder='请输入'
                            onChange={(e) => setProductNumber(e.target.value)}
                            value={productNumber}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={11}>{rff}工单类型</Col>
                    <Col span={11} offset={2}>{rff}工单等级</Col>
                    <Col span={11}>
                        <Select

                            placeholder='工单类型'
                            style={{ width: '100%' }}
                            onChange={(value) => setType(value)}
                            value={type ? type : undefined}
                            disabled={loading}
                            options={CNF.woTypes.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.key
                            }))}
                        />
                    </Col>

                    <Col span={11} offset={2}>
                        <Select

                            placeholder='工单等级'
                            style={{ width: '100%' }}
                            onChange={(value) => setLevel(value)}
                            value={level > 0 ? level : undefined}
                            disabled={loading}
                            options={CNF.woLevels.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.key
                            }))}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={11}>{rff}开始时间</Col>
                    <Col span={11} offset={2}>{rff}结束时间</Col>
                    <Col span={11}>
                        <DatePicker
                            showTime
                            placeholder='开始时间'
                            style={{ width: '100%' }}
                            locale={dateLocale}
                            onChange={(_, dateString) => setStartTime(dateString)}
                            value={dayjs(startTime, 'YYYY-MM-DD hh:mm:ss')}
                            disabled={loading}

                        />
                    </Col>

                    <Col span={11} offset={2}>
                        <DatePicker
                            showTime
                            placeholder='结束时间'
                            style={{ width: '100%' }}
                            locale={dateLocale}
                            onChange={(_, dateString) => setEndTime(dateString)}
                            value={dayjs(endTime, 'YYYY-MM-DD hh:mm:ss')}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={11}>{rff}所属项目</Col>
                    <Col span={11} offset={2}>{rff}工单点位</Col>
                    <Col span={11}>
                        <Select
                            showSearch
                            placeholder='请选择所属项目'
                            style={{ width: '100%' }}
                            onChange={(value) => setProjectUlid(value)}
                            value={projectUlid ? projectUlid : undefined}
                            disabled={loading}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                            options={props.projectLists && props.projectLists.map((item, index) => ({
                                key: index,
                                value: item.key,
                                label: item.name,
                            }))}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder="请输入"
                            onChange={(e) => setPoint(e.target.value)}
                            value={point}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={11}>{rff}工单描述</Col>
                    <Col span={11} offset={2}>{rff}工单原因</Col>
                    <Col span={11}>
                        <TextArea
                            placeholder='工单描述可写在这里....'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setContent(e.target.value)}
                            value={content}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <TextArea
                            placeholder='工单原因可写在这里....'
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            onChange={(e) => setCause(e.target.value)}
                            value={cause}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>处理方式</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='处理方式可写在这里....'
                            autoSize={{ minRows: 2, maxRows: 4 }}
                            onChange={(e) => setDoMode(e.target.value)}
                            value={doMode}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={11}>维护支出</Col>
                    <Col span={11} offset={2}>维护收入：</Col>
                    <Col span={11}>
                        <InputNumber

                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            min={0}
                            step={0.01}
                            style={{ width: '100%' }}
                            onChange={(value) => setOutFee(value)}
                            value={outFee}
                            disabled={loading}
                        />
                    </Col>

                    <Col span={11} offset={2}>
                        <InputNumber
                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            // parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            min={0}
                            step={0.01}
                            style={{ width: '100%' }}
                            onChange={(value) => setInFee(value)}
                            value={inFee}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={11}>工单权重</Col>
                    <Col span={11} offset={2}>{rff}处理人员</Col>
                    <Col span={11}>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            max={10}
                            step={0.1}
                            onChange={(value) => setPerfWeight(value)}
                            value={perfWeight}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                    <Col span={11} offset={2}>
                        <Input
                            placeholder='形如：张三,李四'
                            onChange={(e) => setDoUser(e.target.value)}
                            value={doUser}
                            disabled={props.record ? true : loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里....'
                            autoSize={{ minRows: 2, maxRows: 2 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                {
                    props.btnLists.indexOf('btn_plms_wo_image') >= 0 ? <>
                        <Row style={{ marginTop: CNF.rowMarginTop, lineHeight: 2.2 }}>
                            <Col span={24}>

                                <Upload
                                    beforeUpload={beforeUpload}
                                    name='file'
                                    listType='picture-card'
                                    icon={<PlusOutlined />}
                                    customRequest={(option) => { aliyunOSSUpload(option.file); }}
                                    fileList={fileList}
                                    onPreview={handlePreview}
                                    disabled={loading}
                                    onChange={({ fileList: newFileList }) => {
                                        setFileList(newFileList);
                                    }}
                                    onRemove={(file) => {
                                        let _deleteFileList = deleteFileList;
                                        _deleteFileList.push(file);
                                        setDeleteFileList(_deleteFileList);
                                    }}
                                >
                                    {fileList.length >= CNF.woImageMaxCount ? null : uploadImageButton}
                                </Upload>
                                {previewImage && (
                                    <Image
                                        wrapperStyle={{
                                            display: 'none',
                                        }}
                                        preview={{
                                            visible: previewOpen,
                                            onVisibleChange: (visible) => setPreviewOpen(visible),
                                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                        }}
                                        src={previewImage}
                                    />
                                )}
                            </Col>
                        </Row>
                    </>
                        : ''
                }
            </Modal>
        </ConfigProvider>
    );
}

export default Entity